// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-tab-active":"fEEFO","footerButton":"_1-cPw"};